module.exports = __webpack_public_path__ + "img/PB00.63c58398.svg";